export const roundToFixedPercents = (value: number, fractionDigits = 2) =>
  `${(Math.round(value * 100 * 100) / 100).toFixed(fractionDigits)} %`;
